
import axios from "axios";

// const API_BASE_URL = 'http://localhost:8001/api/dashboard';


export const getPendingJobs = async () => {
  try {
    const response = await axios.get("/dashboard/pending-jobs");
    console.log("Pending Jobs", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching jobs:", error.message);
    throw error;
  }
};

export const getAllJobs = async () => {
  try {
    const response = await axios.get("/dashboard/all-jobs");
    console.log(response.data, "All Jobs");
    return response.data;
  } catch (error) {
    console.error("Error fetching jobs:", error.message);
    throw error;
  }
};

export const getPendingPayments = async () => {
  try {
    const response = await axios.get("/dashboard/pending-payments");
    console.log(response.data, "total outstanding");
    return response.data;
  } catch (error) {
    console.error("Error fetching jobs:", error.message);
    throw error;
  }
};
export const getPaidPayments = async () => {
  try {
    const response = await axios.get("/dashboard/paid");
    console.log(response.data, "JOB JOB DATA API");
    return response.data;
  } catch (error) {
    console.error("Error fetching jobs:", error.message);
    throw error;
  }
};

export const getAllCounts = async () => {
  try {
    const response = await axios.get(
      `/dashboard/get-counts`
    );
    //console.log("All Counts:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching counts:", error.message);
    throw error;
  }
};

export const getMonthlyCounts = async (year) => {
  try {
    const response = await axios.get(
      `/dashboard/sales-purchase-counts?year=${year}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching montly purchase sales counts:",
      error.message
    );
    throw error;
  }
};

export const findEmployeeByUserId = async () => {

  const storedUserData = localStorage.getItem('user');
  const userID = JSON.parse(storedUserData).data._id
  try {
    const response = await axios.get(
      `/findEmployeeByUserId/${userID}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching montly purchase sales counts:",
      error.message
    );
    throw error;
  }
};

export const getNoOfEmployee = async (branchname, startDate, endDate) => {
  try {
    const response = await axios.get('/dashboard/all-employee-count', {
      params: {
        branch: branchname,
        dateFrom:startDate,
        dateTo:endDate
      }
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching monthly employee count:",
      error.message
    );
    throw error;
  }
};


// export const countLateAttendence = async (date) => {
//   try {
//     const response = await axios.get(
//       `http://${BASE_URL}:8000/api/countLateAttendence/${date}`
//     );
//     return response;
//   } catch (error) {
//     console.error(
//       "Error fetching montly purchase sales counts:",
//       error.message
//     );
//     throw error;
//   }
// };

// http://${BASE_URL}:8000/api/
export const countLateAttendence_and_Leaves = async (startDate, endDate, branchname) => {
  try {
    console.log(startDate,"START",endDate,"END")
    const response = await axios.get('/dashboard/count-employee-details', {
      params: {

        branch: branchname,
        dateFrom:startDate,
        dateTo:endDate

      }
    });
    
    return response;
  } catch (error) {
    console.error(
      "Error fetching montly purchase sales counts:",
      error.message
    );
    throw error;
  }
};


export const getLateAttendence = async (startDate, endDate, branchname) => {
  try {
    console.log(startDate,"START",endDate,"END")
    const response = await axios.get('/dashboard/late-attendance-count', {
      params: {

        branch: branchname,
        dateFrom:startDate,
        dateTo:endDate

      }
    });
    
    return response;
  } catch (error) {
    console.error(
      "Error fetching late attendance counts:",
      error.message
    );
    throw error;
  }
};


export const getRoleById = async () => {
  try {
    const roleId="679879fa511fa01415bfdb22"
    const response = await axios.get(`/rolesPermissions/${roleId}`);
    console.log("Role Data:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching role:", error.response?.data || error.message);
    return null;
  }
};


export const getAttendanceCountByBranch = async (branch, dateFrom, dateTo) => {
  try {
    const response = await axios.get('/dashboard/attendance-branch', {
      params: {
        branch,
        dateFrom,
        dateTo,
        limit: 1000 
      }
    });
    
    // Count present records (status === true)
    const presentCount = response.data.data.filter(record => 
      record.status === true
    ).length;
    
    return presentCount;
  } catch (error) {
    console.error("Error fetching attendance count by branch:", error);
    throw error;
  }
};

export const getAttendanceCountByBranchCount = async (startDate, endDate, branch) => {
  try {
    const response = await axios.get('/dashboard/attendance-branch-count', {
      params: { branch, dateFrom: startDate, dateTo: endDate }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching attendance count:", error);
    throw error;
  }
};

export const getMonthlyAttendanceByBranch = async (startDate, endDate) => {
  try {
    const response = await axios.get('/dashboard/monthly-attendance-by-branch', {
      params: {   dateFrom:startDate,
        dateTo:endDate }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching monthly attendance by branch:", error);
    throw error;
  }
};

export const getTodayBirthdays = async (branch) => {
  try {
    const response = await axios.get(`dashboard/today-birthdays`, {
      params: { branch }
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch today\'s birthday employees');
  }
};

export const getThisWeekBirthdays = async (branch) => {
  try {
    const response = await axios.get(`dashboard/week-birthdays`, {
      params: { branch }
    });
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch this week's birthday employees");
  }
};

export const getTodayLeaves = async (branch) => {
  try {
    const response = await axios.get(`/dashboard/today-leaves`, {
      params: { branch }
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch today\'s leave employees');
  }
};

export const getMonthLeaves = async (branch) => {
  try {
    const response = await axios.get(`/dashboard/month-leaves`, {
      params: { branch }
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch this month\'s leave employees');
  }
};

export const getProbationEndEmployees = async (branch) => {
  try {
    const response = await axios.get("/dashboard/probation-end", {
      params: { branch }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching probation end employees:", error);
    throw error;
  }
};


